// src/providers/AuthGate.tsx
import React from "react";
import { auth, setupAuthPersistence } from "../firebase/auth";
import { onAuthStateChanged } from "firebase/auth";

export default function AuthGate({
  children,
  fallback = null,
}: {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}): React.ReactElement {
  const [ready, setReady] = React.useState(false);

  React.useEffect(() => {
    let unsub = () => {};
    (async () => {
      await setupAuthPersistence();
      unsub = onAuthStateChanged(auth, async (user) => {
        // fuerza una sola vez el refresh del token (para que apliquen los custom claims)
        if (user) {
          try {
            await user.getIdToken(true);
          } catch {}
        }
        setReady(true);
      });
    })();
    return () => unsub();
  }, []);

  if (!ready) return <>{fallback ?? <Splash />}</>;
  return <>{children}</>;
}

function Splash() {
  return (
    <div className="grid min-h-screen place-items-center">
      <div className="rounded-xl border border-surface bg-surface px-6 py-4 shadow-soft">
        <div className="h-4 w-40 animate-pulse rounded bg-black/10 dark:bg-white/10" />
      </div>
    </div>
  );
}
